<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('activated')"></b-tab>
          <b-tab :title="$t('deactivated')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>

            <promotion-export :filter="filterFormModel" :total-count="itemCount"
                              v-if="['owner', 'admin', 'account'].includes($store.state.user.role)"></promotion-export>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting"
             v-if="['owner', 'admin', 'operationsManager', 'account'].includes($store.state.user.role)"
        >
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-md-4">{{ $t("codeInfo") }}</div>
            <div class="col-md-3">{{ $t("info") }}</div>
            <div class="col-md-3">{{ $t("status") }}</div>
            <div class="col-md-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-md-4">
              <div>
                <b>{{ $t('code') }}: </b>
                <span style="text-transform: uppercase">{{ item.code }}</span>
              </div>
              <div v-if="item.description">
                <b>{{ $t('description') }}: </b>
                <span>{{ item.description }}</span>
              </div>
              <div v-if="item.type === 'deposit'">
                <b>{{ $t('amountMoney') }}: </b>
                <span>{{ item.amountMoney | numFormat }}</span>
              </div>
              <div v-if="item.type === 'planOrder'">
                <b>{{ $t('amountDay') }}: </b>
                <span>{{ item.amountDay | numFormat }} {{ $t("day") }}</span>
              </div>
              <div>
                <b>{{ $t('maxNumberUse') }}: </b>
                <span>{{ item.maxNumberUse| numFormat }}</span>
              </div>
              <div>
                <b>{{ $t('amount') }}: </b>
                <span v-if="item.type === 'deposit'">{{ item.depositUsed | numFormat }} / </span>
                <span v-if="item.type === 'planOrder'">{{ item.planOrderUsed | numFormat }} / </span>
                <span>{{ item.amount | numFormat }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div>
                <label v-if="item.type === 'deposit'" class="badge badge-warning mr-1">{{ $t(item.type) }}</label>
                <label v-else-if="item.type === 'planOrder'" class="badge badge-primary mr-1">{{
                    $t(item.type)
                  }}</label>

                <label v-if="item.startTime > Date.now()" class="badge badge-warning mr-1">Chưa đến hạn</label>
                <label v-else-if="item.endTime < Date.now()" class="badge badge-danger mr-1">Hết hạn</label>

                <span v-if="item.isTrial" class="badge badge-info mr-1">{{ $t('isTrial') }}</span>
              </div>
              <div v-if="item.startTime">
                <b>{{ $t("startTime") }}: </b>
                <span>{{ item.startTime | moment("DD/MM/YY HH:mm:ss") }}</span>
              </div>
              <div v-if="item.endTime">
                <b>{{ $t("endTime") }}: </b>
                <span>{{
                    item.endTime | moment("DD/MM/YY HH:mm:ss")
                  }}</span>
              </div>
              <div v-if="!item.startTime && !item.endTime">
                <b>{{ $t("time") }}: </b>
                <span class="badge badge-warning">Không giới hạn thời gian</span>
              </div>
              <div v-if="item.type === 'deposit' && item.amountMoney > 0">
                <b>{{ $t('totalAmountMoney') }}: </b>
                <span>{{ item.depositUsed * item.amountMoney | numFormat }}</span>
              </div>
              <div>
                <b>{{ $t('client') }}: </b>
                <span v-if="item.client && item.client.length > 10">{{ item.client.length }}</span>
                <span v-else-if="item.client && item.client.length">
                    {{ item.client.map(c => `${c.companyName} (${c.domain})`).join(", ") }}
                </span>
                <span v-else class="badge badge-warning">{{ $t('all') }}</span>
              </div>
            </div>
            <div class="col-md-3">
              <div>
                <label v-if="item.active" class="badge badge-success">{{ $t('activated') }}</label>
                <label v-if="!item.active" class="badge badge-danger">{{ $t('deactivated') }}</label>
              </div>
              <div>
                <b>{{ $t("createTime") }}: </b>
                <span>{{ item.createTime | moment("DD/MM/YY HH:mm:ss") }}</span>
              </div>
              <div v-if="item.updateTime">
                <b>{{ $t("updateTime") }}: </b>
                <span>{{ item.updateTime | moment("DD/MM/YY HH:mm:ss") }}</span>
              </div>
              <div>
                <b>{{ $t("createdBy") }}: </b>
                <span>{{ item.createdBy ? item.createdBy.name : "Hệ thống" }}</span>
              </div>
              <div v-if="item.updatedBy">
                <b>{{ $t("updatedBy") }}: </b>
                <span>{{ item.updatedBy ? item.updatedBy.name : "Hệ thống" }}</span>
              </div>

            </div>
            <div class="col-md-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1"
                            v-if="['owner', 'admin', 'operationsManager', 'account'].includes($store.state.user.role)">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1"
                            v-if="['owner', 'admin', 'account'].includes($store.state.user.role) && (!item.depositUsed && !item.planOrderUsed)">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center text-danger" v-if="!items.length">
          <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
          <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
        </div>
        <div class="col-12" v-if="itemCount">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                        @input="load">
          </b-pagination>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-else>{{ $t('notFoundSearch') }}</div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-checkbox-group :label="$t('type')"
                           :options="[{value: 'deposit', text: $t('deposit')}, {value: 'planOrder', text: $t('planOrder')}]"
                           attribute="type" stacked
                           :errors="formErrors" :model="formModel" :disabled="formModel._id">
      </form-checkbox-group>
      <form-input :label="$t('code')" :model="formModel" attribute="code" :errors="formErrors"
                  :disabled="formModel._id"></form-input>
      <form-textarea :label="$t('desc')" :model="formModel" attribute="description"
                     :errors="formErrors"></form-textarea>

      <form-input v-if="formModel.type === 'deposit'" :label="$t('amountMoney')" :model="formModel"
                  attribute="amountMoney" :errors="formErrors"></form-input>
      <form-input v-if="formModel.type === 'planOrder'" :label="$t('amountDay')" :model="formModel"
                  attribute="amountDay" :errors="formErrors"></form-input>

      <client-select :label="$t('client')" :model="formModel" attribute="client" :errors="formErrors"
                     :multiple="true"></client-select>
      <form-input :label="$t('maxNumberUse')" :model="formModel" attribute="maxNumberUse"
                  :errors="formErrors"></form-input>
      <form-input :label="$t('amount')" :model="formModel" attribute="amount" :errors="formErrors"></form-input>

      <form-date-time :label="$t('startTime')" :model="formModel" attribute="startTime" :errors="formErrors"
                      format="DD/MM/YYYY HH:mm:ss"></form-date-time>
      <form-date-time :label="$t('endTime')" :model="formModel" attribute="endTime" :errors="formErrors"
                      format="DD/MM/YYYY HH:mm:ss"></form-date-time>

      <form-checkbox :chk-label="$t('isTrial')" :model="formModel" attribute="isTrial" :errors="formErrors"/>
      <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active" :errors="formErrors"/>
    </b-modal>
  </div>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "@/components/ClientSelect";
import PromotionExport from "./PromotionExport";

export default {
  props: ['client'],
  components: {ClientSelect, PromotionExport},
  mixins: [List, CRUD],
  data: function () {
    return {
      saveLoading: false,
      service: '/promotion',
      autoLoad: false,
      defaultFormModel: {
        type: 'deposit',
        code: null,
        active: true,
        isTrial: false,
        amount: 1,
        maxNumberUse: 1,
        client: null
      },
      defaultFilterFormModel: {
        keyword: null,
        status: 1,
        client: this.client ? this.client._id : null
      },
    }
  },
  i18n: {
    messages: {
      en: {
        promotions: 'Promotions',
        endTime: 'End time',
        startTime: 'Start time',
        desc: 'Description',
        multipleUse: 'Multiple use',
        codeInfo: 'Code information',
        code: 'Code',
        description: 'Description',
        createdBy: 'Created by',
        updatedBy: 'Updated by',
        maxNumberUse: "Số lần sử dụng tối đa/1 khách hàng",
        amount: "Số lượng mã khuyến mại",
        deposit: "Tặng tiền",
        planOrder: "Tặng gói dịch vụ",
        amountMoney: "Số tiền khuyến mãi",
        amountDay: "Số ngày khuyến mãi",
        day: "day",
        totalAmountMoney: "Total amount money",
        isTrial: "Áp dụng cho khách dùng thử"
      },
      vi: {
        promotions: 'Chương trình khuyến mãi',
        endTime: 'Thời gian kết thúc',
        startTime: 'Thời gian bắt đầu',
        desc: 'Mô tả',
        multipleUse: 'Được sử dụng nhiều lần',
        codeInfo: 'Thông tin mã khuyến mại',
        code: 'Mã khuyến mại',
        description: 'Mô tả',
        createdBy: 'Tạo bởi',
        updatedBy: 'Cập nhật bởi',
        maxNumberUse: "Số lần sử dụng tối đa/1 khách hàng",
        amount: "Số lượng mã khuyến mại",
        deposit: "Tặng tiền",
        planOrder: "Tặng gói dịch vụ",
        amountMoney: "Số tiền khuyến mãi",
        amountDay: "Số ngày khuyến mãi",
        day: "ngày",
        totalAmountMoney: "Tổng số tiền khuyến mại",
        isTrial: "Áp dụng cho khách dùng thử"
      }
    }
  },
};
</script>